var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRayShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 313,
    viewBox: "0 0 74 313",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "153.049%",
    y1: "90.579%",
    x2: "-51.351%",
    y2: "90.579%",
    id: "d8tw3jz9ya"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5726",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 -268 568.95)",
    d: "m341.98 544.678-33.166-23.19-38.064-265.296-2.05 312.567z",
    fill: "url(#d8tw3jz9ya)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRayShadow);
export default __webpack_public_path__ + "static/media/ray_shadow.016e20b4b4f331f0e8171a287875b5b4.svg";
export { ForwardRef as ReactComponent };